import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { CaretDown, Envelope, List } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import LogoLargeColor from 'src/assets/image/ic-logo-l-color.svg';
import ImageComponent from './core/image';

export default function Navbar() {

    const [getOpenLanguage, setOpenLanguage] = useState(false);
    const [getPathname, setPathname] = useState('');

    const [getShowMenu, setShowMenu] = useState('');

    const { t, i18n } = useTranslation();

    const listMenu = [
        {
            id: '0',
            href: '/',
            target: '',
            title: t("Home"),
        },
        {
            child: [
                {
                    id: '1.1',
                    href: '/about-us',
                    target: '',
                    title: t("About Us"),
                },
                {
                    id: '1.2',
                    href: '/our-system-policy',
                    target: '',
                    title: t("Our System Policy"),
                },
                {
                    id: '1.3',
                    href: '/our-commitment',
                    target: '',
                    title: t("Our Commitment"),
                }
            ],
            id: '1',
            title: t("About"),
        },
        {
            id: '2',
            href: '/services',
            target: '',
            title: t("Services"),
        },
        {
            id: '3',
            href: '/contact-us',
            target: '',
            title: t("Contact Us"),
        },
        {
            child: [
                {
                    id: '4.1',
                    href: '/complaints',
                    target: '',
                    title: t("Complaints"),
                },
                {
                    id: '4.2',
                    href: '/appeals',
                    target: '',
                    title: t("Appeals"),
                }
            ],
            id: '4',
            // href: '/complaints-and-appeals',
            // target: '',
            title: t("Complaints and Appeals"),
        }
    ];

    useEffect(() => {
        window.onresize = () => CloseMenu();

        setPathname(window.location.pathname);
    }, []);

    useEffect(() => {
        CloseMenu();
    }, [getPathname]);

    const CloseMenu = () => {
        setShowMenu(false);
    };

    const ChangeLanguage = (language) => {
        i18n.changeLanguage(language);

        setOpenLanguage(false);
    };

    return (
        <nav className='bg-white fixed overflow-visible shadow-md top-0 w-full z-[3] lg:relative lg:shadow-none'>
            <div className='border-b relative w-full'>
                <div className='flex gap-3 items-center justify-end max-w-[1280px] mx-auto px-6 py-2 w-full'>
                    <Link to={'mailto:info@naturetrust.id'} className='flex gap-2 items-center'>
                        <Envelope size={16} />
                        <p className='caption2'>info@naturetrust.id</p>
                    </Link>
                    <div className='relative'>
                        <button type='button' className='flex gap-2 items-center' onClick={() => setOpenLanguage(prevState => !prevState)}>
                            {i18n.language}
                            <CaretDown size={16} weight='regular' />
                        </button>
                        {getOpenLanguage ?
                            <div className='absolute bg-white border rounded-md right-0 top-full z-[1]'>
                                <button type='button' className='caption2 px-10 py-2 relative w-full hover:bg-border' onClick={() => ChangeLanguage("en")}>en</button>
                                <hr />
                                <button type='button' className='caption2 px-10 py-2 relative w-full hover:bg-border' onClick={() => ChangeLanguage("id")}>id</button>
                            </div>
                            : null
                        }
                    </div>
                </div>
            </div>
            <div className='flex gap-10 items-center justify-between max-w-[1280px] mx-auto overflow-visible px-6 py-1 relative w-full'>
                <Link to={'/'} className='w-fit'>
                    <ImageComponent src={LogoLargeColor} alt='Logo' className='object-contain w-[136px] lg:w-[232px]' />
                </Link>
                <div className='hidden items-center relative lg:flex'>
                    {listMenu.map(item => {

                        if (item?.child) {
                            return (
                                <div key={item?.id} className='group/container relative'>
                                    <button className={`font-semibold group px-6 py-7 relative ${item?.href === getPathname ? 'text-primary' : ''}`}>
                                        {item?.title}
                                        <div className={`absolute bg-primary bottom-0 duration-300 h-[2px] left-0 transition-all ${item?.href === getPathname ? 'w-full' : 'w-0 group-hover:w-full'}`}></div>
                                    </button>
                                    <div className='absolute hidden pt-3 top-full group-hover/container:block'>
                                        <div className='bg-white flex flex-col py-2 relative rounded-lg'>
                                            {item?.child.map(itemChild => {
                                                if (itemChild?.child) {
                                                    return (
                                                        <div key={item?.id} className='group/container-child max-w-[200px] relative w-full hover:bg-gray-100'>
                                                            <button className={`font-semibold px-6 py-2 relative ${item?.href === getPathname ? 'text-primary' : ''} whitespace-nowrap`}>
                                                                {itemChild?.title}
                                                            </button>
                                                            <div className='absolute hidden pr-3 right-full -top-2 group-hover/container-child:block'>
                                                                <div className='bg-white flex flex-col py-2 relative rounded-lg'>
                                                                    {itemChild?.child.map(itemChildChild => {
                                                                        return (
                                                                            <Link key={itemChildChild?.id} to={itemChildChild?.href} target={itemChildChild?.target} className={`font-semibold px-6 py-3 relative ${item?.href === getPathname ? 'text-primary' : ''} whitespace-nowrap hover:bg-gray-100`} onClick={() => setPathname(itemChildChild?.href)}>
                                                                                {itemChildChild?.title}
                                                                            </Link>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }

                                                return (
                                                    <Link key={itemChild?.id} to={itemChild?.href} target={itemChild?.target} className={`font-semibold px-6 py-3 relative ${item?.href === getPathname ? 'text-primary' : ''} whitespace-nowrap`} onClick={() => setPathname(itemChild?.href)}>
                                                        {itemChild?.title}
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            );
                        }

                        return (
                            <Link key={item?.id} to={item?.href} target={item?.target} className={`font-semibold group px-6 py-7 relative ${item?.href === getPathname ? 'text-primary' : ''} whitespace-nowrap`} onClick={() => setPathname(item?.href)}>
                                {item?.title}
                                <div className={`absolute bg-primary bottom-0 duration-300 h-[2px] left-0 transition-all ${item?.href === getPathname ? 'w-full' : 'w-0 group-hover:w-full'}`}></div>
                            </Link>
                        );
                    })}
                </div>
                <button type='button' className='relative lg:hidden' onClick={() => setShowMenu(prevState => !prevState)}>
                    <List color='#659864' size={28} weight='regular' />
                </button>
                {getShowMenu ?
                    <div className='absolute bg-white border-t flex flex-col h-[calc(100vh-86px)] left-0 overflow-auto py-4 shadow-xl top-full w-full z-[2]'>
                        {listMenu.map(item => {

                            if (item?.child) {
                                return (
                                    <div key={item?.id} className='group/container relative w-full'>
                                        <button className={`font-semibold group px-8 py-7 relative ${item?.href === getPathname ? 'text-primary' : ''} text-start w-full whitespace-nowrap`}>
                                            {item?.title}
                                            <div className={`absolute bg-primary bottom-0 duration-300 h-[2px] left-0 transition-all ${item?.href === getPathname ? 'w-full' : 'w-0 group-hover:w-full'}`}></div>
                                        </button>
                                        <div className='hidden w-full group-hover/container:block'>
                                            <div className='bg-white flex flex-col py-2 relative rounded-lg w-full'>
                                                {item?.child.map(itemChild => {
                                                    if (itemChild?.child) {
                                                        return (
                                                            <div key={item?.id} className='group/container-child relative w-full hover:bg-gray-100'>
                                                                <button className={`font-semibold px-12 py-2 relative ${item?.href === getPathname ? 'text-primary' : ''} text-start w-full whitespace-nowrap`}>
                                                                    {itemChild?.title}
                                                                </button>
                                                                <div className='hidden w-full group-hover/container-child:block'>
                                                                    <div className='bg-white flex flex-col py-2 relative rounded-lg w-full'>
                                                                        {itemChild?.child.map(itemChildChild => {
                                                                            return (
                                                                                <Link key={itemChildChild?.id} to={itemChildChild?.href} target={itemChildChild?.target} className={`font-semibold px-16 py-3 relative ${item?.href === getPathname ? 'text-primary' : ''} whitespace-nowrap hover:bg-gray-100`} onClick={() => setPathname(itemChildChild?.href)}>
                                                                                    {itemChildChild?.title}
                                                                                </Link>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }

                                                    return (
                                                        <Link key={itemChild?.id} to={itemChild?.href} target={itemChild?.target} className={`font-semibold px-10 py-3 relative ${item?.href === getPathname ? 'text-primary' : ''} whitespace-nowrap`} onClick={() => setPathname(itemChild?.href)}>
                                                            {itemChild?.title}
                                                        </Link>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }

                            return (
                                <Link key={item?.id} to={item?.href} target={item?.target} className={`font-semibold group px-8 py-4 relative ${item?.href === getPathname ? 'bg-primary/20 text-primary' : ''} whitespace-nowrap`} onClick={() => setPathname(item?.href)}>
                                    {item?.title}
                                </Link>
                            );
                        })}
                    </div>
                    : null
                }
            </div>
        </nav>
    );
}
